import HeaderContext from 'app/HeaderContext'
import LoadingScreen from 'app/components/LoadingScreen'
import useDodoneCollectionQuery from 'generated/api/dodones/useDodoneCollectionQuery'
import useDodoneQuery from 'generated/api/dodones/useDodoneQuery'
import Timeline from 'app/dodones/day/Timeline'
import useEmblaCarousel from 'embla-carousel-react'

const TimelineItem = React.memo(
  ({ dodoneId }) => {
    const { setText } = useContext(HeaderContext)
    const { isPending, data: { dodone } = {} } = useDodoneQuery({ dodoneId })

    useEffect(() => {
      if (dodone) {
        setText(dodone.listItemText)
        return
      }

      setText('Day Timeline')
    }, [dodone])

    if (isPending) return <LoadingScreen />

    return (
      <div className="p-d flex-1" style={{ scrollY: 'auto' }}>
        <Timeline dodone={dodone} />
      </div>
    )
  },
  (prevProps, nextProps) => {
    return prevProps.dodoneId === nextProps.dodoneId
  }
)

const Timelines = () => {
  const { setText } = useContext(HeaderContext)
  const { isPending, data: { dodones } = {} } = useDodoneCollectionQuery({
    query: { scheme: 'days' }
  })
  const [currentIndex, setCurrentIndex] = useState(0)
  const [loadedIndices, setLoadedIndices] = useState(new Set([0]))
  const [emblaRef, emblaApi] = useEmblaCarousel({
    align: 'start',
    containScroll: 'trimSnaps',
    dragFree: true,
    loop: false,
    skipSnaps: false,
    inViewThreshold: 0.5
  })

  useEffect(() => {
    setText('Days')
  }, [setText])

  // Load adjacent items when index changes
  useEffect(() => {
    if (!dodones) return
    const newLoaded = new Set(loadedIndices)
    for (let i = -1; i <= 1; i++) {
      const index = currentIndex + i
      if (index >= 0 && index < dodones.length) {
        newLoaded.add(index)
      }
    }
    setLoadedIndices(newLoaded)
  }, [currentIndex, dodones])

  useEffect(() => {
    if (emblaApi) {
      emblaApi.on('select', () => {
        setCurrentIndex(emblaApi.selectedScrollSnap())
      })
    }
  }, [emblaApi])

  if (isPending || !dodones) return <LoadingScreen />

  const loadedItems = Array.from(loadedIndices)
    .sort((a, b) => a - b)
    .map((index) => dodones[index])
    .filter(Boolean)

  return (
    <div
      className="fcol flex-1"
      style={{
        width: '100%',
        height: '100%',
        overflowX: 'hidden',
        overflowY: 'auto'
      }}
    >
      <div ref={emblaRef} style={{ height: '100%' }}>
        <div style={{ display: 'flex', height: '100%' }}>
          {loadedItems.map((dodone) => (
            <div
              key={dodone.id}
              style={{
                flex: '0 0 100%',
                minWidth: 0,
                height: '100%'
              }}
            >
              <TimelineItem dodoneId={dodone.id} />
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default Timelines
